// Analytics for the page being edited, in a side panel. The numbers load each
// time the panel opens (it only mounts while open).
import { EditorDrawer } from './EditorDrawer';
import { PageAnalyticsTab } from './PageAnalytics';

export function AnalyticsDrawer({ open, onClose, pageId, hasForm, published, onTrackingSettings }: {
  open: boolean;
  onClose: () => void;
  pageId: string;
  /** The page links a form (leads come from it). */
  hasForm: boolean;
  published: boolean;
  onTrackingSettings?: () => void;
}) {
  return (
    <EditorDrawer open={open} onClose={onClose} title="Analytics">
      {onTrackingSettings && <button type="button" className="btn-ghost mb-5 min-h-11 w-full" onClick={onTrackingSettings}>Analytics and script settings</button>}
      <PageAnalyticsTab pageId={pageId} hasForm={hasForm} published={published} />
    </EditorDrawer>
  );
}
